import React, { createContext, useContext, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { Alert, Snackbar } from '@mui/material'

export const TaskStickyAlertSlotContext = createContext(null)

export const ONE_TIME_MANDATORY_CONFLICT_MESSAGE =
  'Las tareas de una sola ejecución no pueden ser obligatorias. Desmarcamos "Sí, hacerla obligatoria."'

const ALERT_SX = {
  width: '100%',
  maxWidth: 520,
  border: '1px solid #FECDCA',
  bgcolor: '#FEF3F2',
  color: '#B42318',
  alignItems: 'center',
  boxShadow: '0 4px 14px rgba(15, 23, 42, 0.12)',
  '& .MuiAlert-icon': { color: '#D92D20' },
  '& .MuiAlert-message': { fontSize: 14, lineHeight: 1.45 }
}

export default function OneTimeMandatoryAlert({
  open,
  onClose,
  message = ONE_TIME_MANDATORY_CONFLICT_MESSAGE,
  autoHideDuration = 5000,
  sx = {}
}) {
  const slotContext = useContext(TaskStickyAlertSlotContext)
  const alertSlot = slotContext?.node ?? null
  const isInStickyStack = slotContext != null
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose

  useEffect(() => {
    if (!isInStickyStack || !open || !autoHideDuration) return undefined

    const timeoutId = window.setTimeout(() => {
      onCloseRef.current?.()
    }, autoHideDuration)

    return () => window.clearTimeout(timeoutId)
  }, [isInStickyStack, open, autoHideDuration, message])

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') return
    onClose?.()
  }

  if (!open) return null

  if (isInStickyStack) {
    if (!alertSlot) return null

    return createPortal(
      <Alert severity="error" onClose={onClose} sx={{ ...ALERT_SX, width: 'auto', ...sx }}>
        {message}
      </Alert>,
      alertSlot
    )
  }

  return (
    <Snackbar
      open
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        top: { xs: 72, sm: 88 },
        right: { xs: 16, sm: 24 },
        left: 'auto',
        position: 'fixed'
      }}
    >
      <Alert severity="error" onClose={onClose} sx={{ ...ALERT_SX, ...sx }}>
        {message}
      </Alert>
    </Snackbar>
  )
}
